import { api, ApiError } from './client';
import type { Activity, VotesMap } from './types';

const base = (slug: string) => `/trips/${encodeURIComponent(slug)}/api`;

// --- Acts ----------------------------------------------------------------

export interface ActsResponse {
  acts: Activity[];
}

export function fetchActs(slug: string, signal?: AbortSignal): Promise<ActsResponse> {
  return api.get<ActsResponse>(`${base(slug)}/acts`, { signal });
}

// --- Votes ---------------------------------------------------------------

export interface VotesResponse {
  votes: VotesMap;
}

export interface VotePayload {
  actId: string;
  vote: boolean;
  /** Anzeigename des Voters — Backend liest sonst aus dem User-Record. */
  name?: string;
}

export function fetchVotes(slug: string, signal?: AbortSignal): Promise<VotesResponse> {
  return api.get<VotesResponse>(`${base(slug)}/votes`, { signal });
}

export function postVote(slug: string, payload: VotePayload): Promise<VotesResponse> {
  return api.post<VotesResponse>(`${base(slug)}/votes`, payload);
}

// --- Favorites -----------------------------------------------------------
// Backend speichert die Favoriten pro Session-Token. Client schickt bei jedem
// Toggle den Vollbestand (kein Diff) — gleiches Schema wie der vanilla-Client.

export interface FavoritesResponse {
  favorites: string[];
}

export async function fetchFavorites(slug: string, signal?: AbortSignal): Promise<FavoritesResponse> {
  try {
    return await api.get<FavoritesResponse>(`${base(slug)}/favorites`, { signal });
  } catch (err) {
    // Ohne Login (401) ist „keine Favoriten" der sinnvolle Default — wir
    // wollen die UI nicht mit Fehlern bombardieren, der RequireAuth-Wrapper
    // kümmert sich um die Redirect-Logik.
    if (err instanceof ApiError && err.isUnauthorized) {
      return { favorites: [] };
    }
    throw err;
  }
}

export function postFavorites(slug: string, favorites: string[]): Promise<FavoritesResponse> {
  return api.post<FavoritesResponse>(`${base(slug)}/favorites`, { favorites });
}
